import styled from "styled-components";
import {Heading, Text, Box} from "rebass";
import {Input} from "reakit";

export const PageTitle = styled(Heading)`
  font-size: 21px;
  font-weight: 700;
  color: #263039;
  & > span {
      color: #969a9b;
  }
`;

export const StyledInput = styled(Input)`
  //background-color: #ffffff;
  border-radius: 3px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
  overflow: hidden;
`;

export const MetaText = styled(Text)`
  font-size: 12px;
  font-weight: 300;
  color: #969a9b;
`;

export const ContentText = styled(Box)`
  font-size: 15px;
  color: #263039;
  position: relative;
`;
